import { render } from "./LogServerDetailPopup.vue?vue&type=template&id=1583de54&ts=true"
import script from "./LogServerDetailPopup.vue?vue&type=script&lang=ts"
export * from "./LogServerDetailPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__